import {
  React,
  Component
} from 'imports/CommonImports';

import {
  CheckCircleIcon,
} from 'imports/IconsImports';

import {
  SuccessColor,
  FailureColor,
} from 'imports/DesignImports';

import {
  Dialog,
  FlatButton,
} from 'material-ui';

const styles = {
  actionsContainer: {
    display: 'flex',
    padding: '0',
  },
  buttonLabel: {
    color: '#FFFFFF',
  },
  button: {
    borderRadius: '0',
    width: '50%'
  },
  centerText: {
    textAlign: 'center',
  },
  informationContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
  },
  projectsContainer: {
    overflowY: 'scroll',
    maxHeight: '13em',
    minHeight: '13em',
    width: '18em',
    border: '1px solid',
    padding: '0 1em',
  },
  projectName: {
    borderBottom: '1px solid',
    padding: '0.5em'
  },
}
export default class SelectionModalConfirmation extends Component {
  constructor(props){
    super(props);
    this.state = {
      open: true
    };
  }

  handleConfirm = () => {
    this.props.confirm();
    this.handleClose();
  };

  handleCancel = () => {
    this.props.cancel();
    this.handleClose();
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const actions = [
      <FlatButton
        label="Cancelar"
        primary={true}
        onClick={this.handleCancel}
        backgroundColor='#ba0f0f'
        labelStyle={styles.buttonLabel}
        hoverColor='#eab6b8'
        style={styles.button}
      />,
      <FlatButton
        label="Confirmar Selección"
        primary={true}
        onClick={this.handleConfirm}
        backgroundColor='#11AB99'
        labelStyle={styles.buttonLabel}
        hoverColor='#89d6c7'
        style={styles.button}
      />,
    ];

    return (
      <div>
        <Dialog
          actions={actions}
          modal={true}
          open={this.state.open}
          actionsContainerStyle={styles.actionsContainer}
          contentStyle={styles.contentContainer}
        >
          <h2 style={styles.centerText}>¿Estás seguro de tu decisión sobre los proyectos de innovación para medir i3?</h2>
          <div style={styles.informationContainer}>
            <div>
              <h3 style={styles.title}><CheckCircleIcon color={SuccessColor} /> Proyectos Seleccionados ({this.props.passProjects.length})</h3>
              <div style={styles.projectsContainer}>
                {this.props.passProjects.map((project, i) => {
                  return (<div key={project.id} style={styles.projectName}>{i+1}.- {project.information.name}</div>)
                })}
              </div>
            </div>
            <div>
              <h3 style={styles.title}><CheckCircleIcon color={FailureColor} /> Proyectos Descartados ({this.props.dontPassProjects.length})</h3>
              <div style={styles.projectsContainer}>
                {this.props.dontPassProjects.map((project, i) => {
                  return (<div style={styles.projectName}>{i+1}.- {project.information.name}</div>)
                })}
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/selection/SelectionModalConfirmation.js